

























import {Component, Prop} from "vue-property-decorator";
import abpbase from "../../lib/abpbase";
import SearchPage from "../../layouts/searchPage.vue";
import QueryTabList from "@/views/query/list.vue";

@Component({
    name: 'queryIndex',
    components: {QueryTabList, SearchPage}
})
export default class queryIndex extends abpbase {
    @Prop({type: String, default: ''}) keywords: string;

    defRoutes = [ {
        path: 'query',
        breadcrumbName: '搜索'
    }];

    inputVal: string = '';

    tabList: object = [
        {key: 'all', tab: '全部'},
        {key: 'knowledgeBase', tab: '知识库'},
        {key: 'QA', tab: 'Q & A'}];

    tabKey: string = 'all';

    //tab切换
    handleChangeTab(key: string) {
        this.tabKey = key;
        this.showTabList(key);
    }

    //显示列表页
    showTabList(tabKey: string = this.tabKey, keywords: string = this.inputVal) {
        // this.hideDetail();
        this.$nextTick(() => {
            let dic = {knowledgeBase: '1', QA: 2}
            let moduleType = dic[tabKey];
            let listModule: any = this.$refs.queryTabList;
            listModule.show(moduleType, keywords);
        });
    }

    //隐藏列表页
    // hideTabList() {
    //     let listModule: any = this.$refs.queryTabList;
    //     listModule.hide();
    // }

    // //显示详情页
    // showDetail(docId: string) {
    //     if (docId) {
    //         this.hideTabList();
    //         let detailModule: any = this.$refs.kbDetail;
    //         detailModule.show(docId);
    //     }
    // }
    //
    // //隐藏详情页
    // hideDetail() {
    //     let detailModule: any = this.$refs.kbDetail;
    //     detailModule.hide();
    // }

    //关键字搜索
    handleSearch(keywords: string = '') {
        this.inputVal = keywords;
        this.showTabList(this.tabKey, keywords);
    }

    created() {
        // this.keywords = this.inputVal;
        this.inputVal = this.keywords;
        //默认显示列表页
        this.showTabList();
    }
}
